import React, {useEffect, useState} from "react";
import { Layout, theme } from "antd";
import Sidebar from "../../../dash/sideBar";
import Cash from "./cash";
import back from "../../../../../imgs/backIcon.png";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
// import Card from "./Card";
const { Sider } = Layout;
const App = () => {
  const [title, setTitle] = useState("");
  const location = useLocation();
  const dash = location.pathname;
  const {
    token: { borderRadiusLG },
  } = theme.useToken();
  const router = useNavigate();
  useEffect(()=>
  {
    if(dash==="/MHSSS/ewalletcashPay/verify")
    setTitle("Cash payment receipt")
  else if(dash==="/MHSSS/cashPay")
  setTitle("Merchants Outstanding")
  })
  return (
    <Layout
      className=" h-[100vh] rounded-lg"
      style={{
        padding: 35,
        paddingRight: 10,
        margin: 0,
        background: "#D9EFED",
      }}
    >
      <Sider
        breakpoint="lg"
        width={280}
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          console.log(broken);
        }}
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
        className="flex flex-col justify-between h-full"
        style={{
          borderRadius: borderRadiusLG,
          width: "20px",
          height: "screen",
          boxShadow:
            "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
        }}
      >
        <Sidebar />
      </Sider>

      <Layout
        className="flex flex-col items-center justify-center overflow-auto"
        style={{
          background: "#D9EFED",
        }}
      >
        <div className="w-[95%] h-[100vh] overflow-auto">
          <div className="flex items-center w-[95%]">
            <div className="flex items-center justify-center">
              <h2 className="mb-4 text-xl font-bold flex items-center justify-center">
                <img
                  onClick={() => {
                    if (dash === "/MHSSS/ewalletcashPay/verify")
                      router("/MHSSS/ewalletcashPay");
                    else if (dash === "/MHSSS/cashPay")
                      router("/MHSSS/payoutstandings");
                  }}
                  src={back}
                  className="w-3 h-3 mr-2 cursor-pointer"
                  alt="back"
                />{" "}
                {title}
              </h2>
            </div>
          </div>
          <Cash />
        </div>
      </Layout>
    </Layout>
  );
};
export default App;
